import { Icon } from '@chakra-ui/react';
import { IconGradientDefs, getGradientId, getGradientFill, type IconGradient } from './IconGradientDefs';

const CustomSpinIcon = (props: any) => {
  const { gradient, ...rest } = props as { gradient?: IconGradient } & Record<string, unknown>;
  const gradientId = getGradientId('spin', gradient);
  const fillValue = getGradientFill(gradientId, (props.color as string) || '#AEAEAE');

  return (
    <Icon viewBox="0 0 41 27" fill="none" {...rest}>
      {gradientId && <IconGradientDefs gradientId={gradientId} gradient={gradient!} />}
      <path
        d="M20.5 0C9.225 0 0 4.56923 0 10.3846C0 14.9538 5.945 18.9 14.35 20.3538V27L22.55 18.6923L14.35 10.3846V15.9923C7.79 14.7462 4.1 12.0462 4.1 10.3846C4.1 8.1 10.25 4.15385 20.5 4.15385C30.75 4.15385 36.9 8.1 36.9 10.3846C36.9 11.8385 33.825 14.3308 28.7 15.5769V19.9385C35.875 18.2769 41 14.7462 41 10.3846C41 4.56923 31.775 0 20.5 0Z"
        fill={fillValue}
      />
    </Icon>
  );
};

export default CustomSpinIcon;
